import { render } from "./candidates_job_tab.vue?vue&type=template&id=76185fb0"
import script from "./candidates_job_tab.vue?vue&type=script&lang=js"
export * from "./candidates_job_tab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__